module.exports = __webpack_public_path__ + "img/run-co-bmw.d668f702.png";